import { T } from '@salecycle/experimental/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { EmailTemplate } from './components/EmailTemplate';
import { Divider } from '../Divider';
import { SubjectLine } from './components/SubjectLine';
import { useCampaignEditorContext } from '../../state/hooks/useCampaignEditorContext';
import styled from 'styled-components';
import { theme } from '@salecycle/ui-component-library';
import { TargetAudienceType } from '../../state/CampaignEditorState';

const ContentBackground = styled.div`
  background-color: ${({ theme }) => theme.designToken.neutral50};
  padding: ${({ theme }) => theme.designToken.spacing5};
  display: flex;
  gap: ${({ theme }) => theme.designToken.spacing2};
  align-items: center;
`;

export const ContentTab = () => {
  const { t } = useTranslation('campaigns');
  const { state } = useCampaignEditorContext();

  return (
    <>
      <T variant="headingH1">{t('bulkRetargetingCampaigns.editor.tabs.content')}</T>
      <T variant="body1">{t('bulkRetargetingCampaigns.editor.contentSelectionText')}</T>
      <div style={{ display: 'flex', gap: theme.designToken.spacing3, flexDirection: 'row' }}>
        {state.campaign.targetAudience.map((targetAudience, index) => (
          <ContentBackground key={index}>
            <div
              style={{ display: 'flex', gap: theme.designToken.spacing1, alignItems: 'start', flexDirection: 'column' }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', gap: theme.designToken.spacing1 }}>
                <T variant="headingH2">
                  {targetAudience.audience === TargetAudienceType.BasketAbandonment &&
                    t('bulkRetargetingCampaigns.editor.abandonedABasket')}
                  {targetAudience.audience === TargetAudienceType.BrowseAbandonment &&
                    t('bulkRetargetingCampaigns.editor.browsedWithoutPurchasing')}
                  {targetAudience.audience === TargetAudienceType.Purchase &&
                    t('bulkRetargetingCampaigns.editor.madeAPurchase')}
                </T>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: theme.designToken.spacing3 }}>
                <EmailTemplate targetAudience={targetAudience?.audience} />
                <Divider />
                <SubjectLine targetAudience={targetAudience?.audience} />
              </div>
            </div>
          </ContentBackground>
        ))}
      </div>
    </>
  );
};
